<template>
  <div class="container">
    <header class="site-header">
      <!-- Navigation is handled by parent component -->
    </header>
    <main class="main-content" id="main-content">
      <div
        class="logo"
        :class="{
          'shift-left-logo': hoveredButton === 'search',
          'shift-right-logo': hoveredButton === 'join'
        }"
      >
        <svg viewBox="0 0 200.1 103.46" xmlns="http://www.w3.org/2000/svg" class="loader" aria-label="PALLAS - PortAL Linking Artists and Scientists logo" role="img">
        <defs></defs>
        <g id="Layer_5" fill="#f8b19b">
          <path class="cls-2" d="m21.3,67.38v-17.83c0-.68.55-1.22,1.22-1.22h6.88c3.98,0,6.91,2.36,6.91,6.46s-2.93,6.46-6.91,6.46h-5.03v4.92c0,.68-.55,1.22-1.22,1.22h-1.85Zm3.07-16.29v7.39h5.4c2.5,0,3.5-.97,3.5-3.7s-1-3.7-3.5-3.7h-5.4Z"/>
          <path class="cls-2" d="m48.92,67.37l7.42-19.05h3.23c.71,0,1.35.44,1.61,1.1l6.55,16.82c.21.55-.19,1.14-.78,1.14h-2.11l-.76-1.94c-.19-.48-.54-.88-1-1.12l-6.12-3.26c-1.04-.55-2.32-.08-2.75,1.01l-1.64,4.17c-.27.69-.95,1.15-1.69,1.15h-1.96Zm13.52-6.19l-2.6-6.55-1.22-3.53h-.23l-1.25,3.53-.79,2c-.15.38,0,.8.34,1.01l5.75,3.54Z"/>
          <path class="cls-2" d="m150.98,66.24l-6.55-16.82c-.26-.66-.9-1.1-1.61-1.1h-3.23l-7.42,19.05h2.09c.75,0,1.42-.46,1.69-1.15l.31-.79c.19-.48.54-.88,1-1.12l6.12-3.26c1.04-.55,2.32-.08,2.75,1.01l2.1,5.32h1.98c.59,0,.99-.6.78-1.14Zm-13.07-5.05l2.6-6.55,1.22-3.53h.23l1.25,3.53.79,2c.15.37,0,.8-.34,1.01l-5.75,3.54Z"/>
          <path class="cls-2" d="m80.53,66.15v-17.83h1.85c.68,0,1.22.55,1.22,1.22v15.07h8.93c.68,0,1.22.55,1.22,1.22v1.53h-12c-.68,0-1.22-.55-1.22-1.22Z"/>
          <path class="cls-2" d="m106.35,66.15v-17.83h1.85c.68,0,1.22.55,1.22,1.22v15.07h8.93c.68,0,1.22.55,1.22,1.22v1.53h-12c-.68,0-1.22-.55-1.22-1.22Z"/>
          <path class="cls-1" d="m198.46,48.55c-.34-.39-.74-.75-1.18-1.03-1.51-.94-3.52-1.06-5.14-.8,1.52-.4,2.36-.93,3.02-1.23,2.16-.98,3.28-3.43,2.38-5.63-2.18-5.29-5.37-9.58-10.18-13.69-1.99-1.7-4.52-2.67-7.14-2.68-2.78-.02-5.41-.18-7.34.76,3.23-1.81,3.19-6.11-.34-8.25-5.67-3.27-8.7-4.86-15.39-7.13-3.58-1.22-7.5-1.05-10.95.51-1.57.72-3.56,1.58-4.14,2.07.42-.35.79-1.38,1.07-2.54.55-2.3-.66-4.06-2.83-4.68-9.99-2.86-22.76-3.88-34.37-4.22-1.37-.04-2.67.59-3.51,1.67-.12.15-.24.31-.35.47-1.3,1.75-1.97,6.04-1.97,6.04,0,0-.73-4.29-2.03-6.04-.12-.16-.23-.31-.35-.47-.83-1.09-2.14-1.71-3.51-1.67-11.62.34-24.38,1.36-34.37,4.22-2.17.62-3.38,2.39-2.83,4.68.28,1.16.65,2.19,1.07,2.54-.58-.48-2.57-1.35-4.14-2.07-3.45-1.57-7.37-1.73-10.95-.51-6.7,2.28-9.73,3.86-15.39,7.13-3.53,2.14-3.57,6.43-.34,8.25-1.92-.95-4.56-.78-7.34-.76-2.62.02-5.15.98-7.14,2.68-4.81,4.11-8,8.4-10.18,13.69-.91,2.2.21,4.65,2.38,5.63.66.3,1.5.83,3.02,1.23-1.63-.26-3.64-.14-5.14.8-.45.28-.84.64-1.18,1.03-1.3,1.49-1.78,3.51-1.6,5.48.51,5.61,3.02,11.81,7.17,16.97,1.71,2.13,3.9,3.45,6.62,3.19,1.07-.1,3.93-1.21,4.98-1.82-1.6.86-1.84,1.05-2.44,2.06-1.32,2.23-.74,5.33,1.35,6.86,6.95,5.08,17.4,10.52,29.2,14.18,1.35.42,2.79.47,4.18.17.97-.21,2.21-.79,2.61-1.16.58-.35,1.17-.69,1.75-1.03.69-.41,1.5-1.08,2.26-1.3-.68.78-1.58,1.22-2.06,2.23-.85,1.75.07,3.67,1.93,4.14,11.4,2.92,26.17,4.92,41.76,4.92h1.44c15.58,0,30.36-2.01,41.76-4.92,1.86-.48,2.78-2.39,1.93-4.14-.49-1.01-1.38-1.44-2.06-2.23.76.22,1.57.89,2.26,1.3.58.34,1.17.68,1.75,1.03.4.38,1.64.95,2.61,1.16,1.38.3,2.82.25,4.18-.17,11.79-3.65,22.25-9.09,29.2-14.18,2.09-1.53,2.68-4.63,1.35-6.86-.6-1.01-.85-1.2-2.44-2.06,1.05.61,3.91,1.71,4.98,1.82,2.72.26,4.91-1.07,6.62-3.19,4.15-5.16,6.65-11.37,7.17-16.97.18-1.97-.3-3.99-1.6-5.48Zm-55.95-32.25c4.75-3.09,7.99-3.96,12.22-2.5,2.95,1.02,5.87,2.15,8.73,3.41,1.26.55,2.57,1.09,3.79,1.71.03.01.06.03.08.04.99.54,1.7,1.6,1.75,2.73.12,2.64-2.52,3.33-4.44,4.21-2.35,1.09-4.66,2.26-6.93,3.52-6.05,3.37-11.75,7.36-16.99,11.89-1.5,1.3-3.62,1.59-5.42.77-2.36-1.07-5.08-2.26-7.78-3.07-1.65-.49-2.35-2.43-1.46-3.91,5.19-8.61,12.54-16.27,16.43-18.81Zm-9.55,32.51c-3.24,3.24-5.74,5.86-7.85,9.28-.82,1.32-2.44,1.65-3.85.99-1.47-.69-3.07-1.31-4.78-1.85-1.22-.38-1.84-1.56-1.4-2.75,1.56-4.19,3.38-8.4,5.79-11.1.87-.98,2.91-1.93,4.21-1.75,2.5.34,6.89,2.28,7.45,2.68,1.78,1.27,1.64,3.29.43,4.5Zm-30.02-39.68c.09-2.14,1.92-3.81,4.06-3.74,9.41.34,18.43,1.35,26.88,2.94,2.7.51,3.9,3.72,2.14,5.83-5.05,6.08-9.8,12.73-13.79,19.52-1.14,1.95-3.36,2.96-5.59,2.6-3.5-.57-7.16-.96-10.95-1.16-2.12-.11-3.76-1.9-3.67-4.02l.93-21.98Zm-17.9,46.79v4.31c2.28-.67,4.77-1.2,7.42-1.54.09-.01.17-.02.26-.03.35-.04.71-.08,1.07-.12,1.77-.2,3.58-.32,5.45-.35h1.64c1.38.02,2.72.11,4.04.23v-3.26c-.45-.03-.9-.08-1.36-.11-1.4-.08-2.49-1.19-2.44-2.59l.46-10.97c.06-1.39,1.39-3.04,2.75-3.35.45-.1,7.79.38,11.37,1.16,1.39.3,2.1,2.7,1.5,3.99-1.56,3.33-2.97,6.74-4.2,10.2-.36,1.02-1.16,1.72-2.13,2.02v3.72c10.41,2.01,17.75,6.82,17.75,12.45,0,.84-.17,1.66-.48,2.45l-.05.14c-1.03,2.49-3.52,4.73-7.03,6.53l-.25.12c-4.95,2.47-11.87,4.06-19.57,4.2h-2.36c-7.7-.15-14.62-1.73-19.57-4.2l-.25-.12c-3.51-1.79-5.99-4.04-7.03-6.53l-.05-.14c-.31-.79-.48-1.61-.48-2.45,0-3.53,2.89-6.74,7.6-9.14v-3.56c-.08.04-.17.07-.25.11-1.41.66-3.03.33-3.85-.99-2.11-3.42-4.61-6.04-7.85-9.28-1.21-1.21-1.35-3.23.43-4.5.55-.4,4.94-2.33,7.45-2.68,1.3-.18,3.33.77,4.21,1.75.88.99,1.68,2.18,2.42,3.5h.72c1.47,0,2.66,1.19,2.66,2.66v6.38Zm54.61,20.32c.61-.1.92.19.41.54-2.32,1.6-5.9,3.68-8.91,4.77-3.32,1.2-3.32,1.14-7.63,1.58,1.88-.97,2.4-1.57,3.21-2.02,5.87-3.19,9.95-4.36,12.92-4.87Zm-63.06,6.89c-4.31-.44-4.31-.38-7.63-1.58-3.02-1.09-6.59-3.17-8.91-4.77-.51-.35-.2-.64.41-.54,2.96.51,7.05,1.68,12.92,4.87.81.44,1.33,1.04,3.21,2.02Zm22.41-30.68c.06,1.4-1.04,2.51-2.44,2.59-1.96.11-3.85.3-5.68.58-1.63.25-3.21-.59-3.76-2.15-1.24-3.46-2.64-6.87-4.2-10.2-.61-1.29.1-3.69,1.5-3.99,3.58-.78,10.93-1.26,11.37-1.16,1.35.31,2.69,1.97,2.75,3.35l.46,10.97ZM66.23,8.33c8.45-1.59,17.47-2.6,26.88-2.94,2.14-.08,3.97,1.6,4.06,3.74l.93,21.98c.09,2.12-1.55,3.91-3.67,4.02-3.79.2-7.46.59-10.95,1.16-2.23.37-4.45-.65-5.59-2.6-3.99-6.79-8.74-13.44-13.79-19.52-1.76-2.12-.56-5.32,2.14-5.83Zm-33.46,10.63s.05-.03.08-.04c1.22-.62,2.53-1.16,3.79-1.71,2.86-1.26,5.78-2.39,8.73-3.41,4.23-1.46,7.47-.59,12.22,2.5,3.9,2.53,11.24,10.2,16.43,18.81.89,1.47.19,3.41-1.46,3.91-2.69.81-5.41,2-7.78,3.07-1.81.82-3.92.52-5.42-.77-5.24-4.53-10.94-8.52-16.99-11.89-2.26-1.26-4.57-2.44-6.93-3.52-1.92-.88-4.56-1.58-4.44-4.21.05-1.13.76-2.19,1.75-2.73Zm16.19,49.85c-.05.75-.57,1.99-2.09,1.69-9.7-1.89-19.69-2.26-29.56-.94-2.66.36-5.34-.71-6.88-2.9-2.6-3.69-4.27-7.59-4.88-11.64-.42-2.82,1.92-4.66,4.66-5.26,1.77-.39,5.32-.18,9.67.44v-.67c0-1.47,1.2-2.66,2.66-2.66h5.48c-5.16-1.28-10.4-2.25-15.63-2.87-2.87-.34-4.34-3.59-2.8-6.04,1.55-2.46,3.51-4.83,5.84-7.1,2.6-2.53,6.31-3.08,9.89-2.53,8.95,1.37,21.84,6.66,31.1,15.24.99.91,1.23,2.29.54,3.29.36-.08.74-.12,1.14-.13,2.7-.05,4.71,1.77,5.45,2.53,3.71,3.27,7.32,6.22,10.16,10.99.43.72.29,1.64-.36,2.17-1.31,1.07-2.39,2.23-3.2,3.46-.38.55-.83,1.31-1.19,2.27-.33.88-.5,1.68-.58,2.31-.36,2.06.47,4.48.59,4.77.31.79,0,1.19-.79.89-4.55-1.7-6.44-2.4-10.52-3.44-1.4-.36-2.9-.81-4.06-2.3-.36-.46-.69-.75-1.09-1.58h-3.54Zm6.89,21.13c-2.08,1.19-4.57,1.47-6.85.75-10.02-3.16-18.73-7.21-25.69-11.93-1.61-1.09-.91-2.99.71-4.07,3.51-2.34,16.51-2.66,25.51-.56.28.07.54.1.94.2,1.24.3,2.68.65,4.51,2.24,4,3.47,5.45,4.21,9.46,6.32,1.07.57.92,2.01-.17,2.55-3,1.5-5.59,2.89-8.41,4.5Zm81.22,4.43c-11.35,2.54-23.24,4.61-36.29,4.64h-1.44c-13.04-.03-24.94-2.11-36.29-4.64-1.45-.32-1.74-1.92-.94-3.17,1.93-3.02,4.64-4.49,6.77-4.6,1.72-.09,3.78-.31,5.46.17,7.58,2.13,15.61,3.52,25,3.52h1.44c9.39,0,17.42-1.39,25-3.52,1.68-.47,3.74-.26,5.46-.17,2.13.11,4.84,1.58,6.77,4.6.8,1.25.51,2.85-.94,3.17Zm39.75-15.61c-6.96,4.72-15.67,8.77-25.69,11.93-2.29.72-4.77.44-6.85-.75-2.82-1.61-5.41-3-8.41-4.5-1.09-.54-1.24-1.99-.17-2.55,4.01-2.11,5.46-2.85,9.46-6.32,1.83-1.58,3.26-1.94,4.51-2.24.4-.1.66-.13.94-.2,9-2.1,22-1.78,25.51.56,1.62,1.08,2.32,2.98.71,4.07Zm-29.3-9.95c-.36.73-.72,1.14-.99,1.57-.98,1.61-2.66,1.94-4.06,2.3-4.07,1.04-5.97,1.74-10.52,3.44-.79.3-1.11-.1-.79-.89.12-.3.95-2.72.59-4.77-.1-.51-.23-1.08-.43-1.68-.38-1.18-.88-2.15-1.34-2.91-.81-1.23-1.89-2.39-3.2-3.46-.64-.53-.79-1.45-.36-2.17,2.84-4.77,6.45-7.72,10.16-10.99,1.01-.88,2.9-2.22,5.45-2.38.41-.03.79-.02,1.16.01-.72-1-.47-2.39.52-3.32,9.26-8.58,22.15-13.87,31.1-15.24,3.58-.55,7.29,0,9.89,2.53,2.33,2.27,4.28,4.64,5.84,7.1,1.54,2.45.08,5.7-2.8,6.04-5.04.6-10.09,1.51-15.08,2.73,2.75.4,4.79,1.7,5.91,3.72,5.11-.81,9.35-1.13,11.34-.69,2.74.6,5.08,2.44,4.66,5.26-.6,4.04-2.28,7.94-4.88,11.64-1.54,2.19-4.22,3.26-6.88,2.9-2.93-.39-5.87-.62-8.81-.72-.96-.03-1.95-.05-2.97-.05-.86,0-1.69,0-2.51.03-5.13.14-10.24.7-15.27,1.68-1.67.33-2.14-.99-2.1-1.69h-3.64Z"/>
          <path class="cls-1" d="m162.2,53.47c0-1.48.5-2.97,1.54-4.18-3.74,1.23-7.43,2.64-10.99,4.27-1.32.61-3.13.21-4.03-.94-.8-1.03-1.7-2.07-2.69-3.07l5.91,15.17s0-.03,0-.05c.3-2.18,0-4.14-.17-5.51-.13-1.08,1.07-2.01,2.09-2.4,2.49-.94,5.35-1.85,8.37-2.69-.01-.19-.04-.38-.04-.59Z"/>
          <path class="cls-1" d="m48.32,59.15c-.16,1.37-.47,3.34-.17,5.51.02.16.06.31.09.47l6.22-15.97c-1.16,1.12-2.18,2.3-3.08,3.45-.89,1.15-2.7,1.55-4.03.94-3.9-1.78-7.93-3.31-12.03-4.62,1.38,1.24,2.24,2.98,2.4,5.07,3.07.85,5.99,1.78,8.51,2.73,1.02.39,2.22,1.32,2.09,2.4Z"/>
          <path class="cls-2" d="m163.64,62.29c-.05-.71.51-1.31,1.22-1.31h1.73s.02.87.03.99c.03.33.1.63.2.91.48,1.31,1.78,1.97,4.75,1.97s3.84-.77,3.84-2.53-.57-2.36-3.5-2.96l-3.24-.66c-3.27-.62-5.03-2.22-5.03-5.23,0-2.82,2.19-5.43,7.11-5.43,4.39,0,6.58,2.06,7.19,4.71.04.17.07.35.1.53.05.36.08,1.45.08,1.45h-2.36c-.37,0-.67-.29-.69-.65-.01-.28-.04-.58-.06-.72-.02-.13-.06-.25-.09-.37-.42-1.39-1.63-2.12-4.25-2.12-2.82,0-3.95.8-3.95,2.48s.77,2.22,3.38,2.79l3.24.68c3.58.74,5.15,2.53,5.15,5.4s-2.16,5.46-7.02,5.46-7.25-1.95-7.77-4.92c-.02-.09-.03-.25-.04-.45Z"/>
        </g>
      </svg>
    </div>
    <section class="intro-section">
      <div class="welcome-box">
        <h1 class="visually-hidden">PALLAS - Connecting Artists and Scientists</h1>
        <p class="intro">
          Welcome to the PortAL Linking Artists and Scientists: a database designed to weave art into the fabric of the scientific ecosystem.
        </p>
        <router-link to="/AboutUs" class="bubbles blend-bubbles" aria-label="Learn more about PALLAS">
          <span class="text">Learn More</span>
        </router-link>
      </div>
    </section>
    <section class="cta-section">
      <div class="title-buttons">
        <div
          class="button-group join-group"
          :class="{ 'shift-left': hoveredButton === 'join' }"
          @mouseenter="hoveredButton = 'join'"
          @mouseleave="hoveredButton = null"
          @focus="hoveredButton = 'join'"
          @blur="hoveredButton = null"
          role="group"
          aria-labelledby="artist-question"
        >
          <div class="description">
           <span class="question-text" id="artist-question">Are you an <span class="artist-text">artist</span> interested in scientific work?</span>
            <button class="bubbles artist-bubbles" @click="() => openSignUpModal('artist')" @keydown.enter="() => openSignUpModal('artist')" aria-label="Join PALLAS as an artist - Sign up to connect with scientists" tabindex="0">
              <span class="text">Join PALLAS</span>
            </button>
          </div>
        </div>
        <div
          class="button-group search-group"
          :class="{ 'shift-left': hoveredButton === 'search' }"
          @mouseenter="hoveredButton = 'search'"
          @mouseleave="hoveredButton = null"
          @focus="hoveredButton = 'search'"
          @blur="hoveredButton = null"
          role="group"
          aria-labelledby="scientist-question"
        >
          <div class="description">
          
            <span class="question-text" id="scientist-question">Are you a <span class="scientist-text">scientist</span> interested in artistic work?</span>
            <button class="bubbles scientist-bubbles" @click="() => openSignUpModal('scientist')" @keydown.enter="() => openSignUpModal('scientist')" aria-label="Join PALLAS as a scientist - Sign up to connect with artists" tabindex="0">
              <span class="text">Join PALLAS</span>
            </button>
          
           </div>
        </div>
      </div>
    </section>
    </main>
  </div>
</template>

<script>

import { openSignUpModal } from '@/composables/useAuthModal';

export default {
  components: {},
  data() {
    return {
      hoveredButton: null
    };
  },
  methods: {
    openSignUpModal
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  padding: 0 1rem 4rem 1rem;
  max-width: 100vw;
}

.site-header {
  width: 100%;
}

.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
}

.logo {
  margin-top: clamp(4rem, 12vh, 6rem);
  width: min(80vw, 38rem);
  max-width: 38rem;
  margin-bottom: clamp(1.5rem, 4vh, 2.5rem);
  transition: transform 0.5s ease;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.logo svg .cls-1 {
  fill: var(--neutralColor) !important;
  stroke: var(--artColor) !important;
}

.logo svg .cls-2 {
  fill: var(--sciColor) !important;
}

.logo svg path {
  stroke-width: .3px;
  animation: dashArray 11s ease-in-out infinite, dashOffset 10s linear infinite;
  will-change: stroke-dasharray, stroke-dashoffset;
}

/* Respect user's motion preferences */
@media (prefers-reduced-motion: reduce) {
  .logo svg path {
    animation: none;
  }
}

@keyframes dashArray {
  0% {
    stroke-dasharray: 0 1 359 0;
  }
  50% {
    stroke-dasharray: 0 359 1 0;
  }
  100% {
    stroke-dasharray: 359 1 0 0;
  }
}

@keyframes dashOffset {
  0% {
    stroke-dashoffset: 365;
  }
  100% {
    stroke-dashoffset: 5;
  }
}

.intro-section {
  text-align: center;
  margin: 0 auto 1rem;
  max-width: 50rem;
}

.welcome-box {
  border-radius: var(--stdRadius);
  padding: 2rem 2rem 3rem 2rem;
  margin: 0 1rem;
  position: relative;
  background: var(--bckColor);
  box-shadow: 0 0 0.2em 0 var(--blendOutlineColor);
  overflow: hidden;
}

.welcome-box::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(90deg, var(--artOutlineColor) 0%, var(--sciOutlineColor) 100%);
  border-radius: var(--stdRadius);
  z-index: -1;
  opacity: 1;
}

.welcome-box::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bckColor);
  border-radius: var(--stdRadius);
  z-index: -1;
}


.welcome-box > * {
  position: relative;
  z-index: 1;
}

.intro {
  font-size: clamp(1.1rem, 3vw, 1.4rem);
  line-height: 1.7;
  margin: 0 0 1.5rem 0;
  padding: 0;
  color: var(--textColor);
}


/* Bubble button styling adapted from Uiverse.io by nikk7007 */
.bubbles {
  --size-letter: clamp(1rem, 2.5vw, 1.4rem);
  padding: 0.5em 1em;
  font-size: var(--size-letter);
  font-family: var(--font-primary);
  
  background-color: transparent;
  border-radius: var(--stdRadius);
  cursor: pointer;
  
  overflow: hidden;
  position: relative;
  display: inline-block;
  transition: 150ms cubic-bezier(0.83, 0, 0.17, 1);
}

.bubbles > .text {
  font-weight: 700;
  position: relative;
  z-index: 1;
  transition: color 350ms cubic-bezier(0.83, 0, 0.17, 1);
}

.bubbles::before {
  top: 0;
  left: 0;
}

.bubbles::after {
  top: 100%;
  left: 100%;
}

.bubbles::before,
.bubbles::after {
  content: "";
  width: 150%;
  aspect-ratio: 1/1;
  scale: 0;
  transition: 500ms cubic-bezier(0.76, 0, 0.24, 1);
  
  border-radius: 50%;
  
  position: absolute;
  translate: -50% -50%;
}

.bubbles:hover {
  & > .text {
    color: var(--bckColor);
  }
  &::before,
  &::after {
    scale: 1;
  }
}

.bubbles:active {
  scale: 0.98;
  filter: brightness(0.9);
}

/* Artist-themed bubble styling */
.artist-bubbles {
  border: calc(var(--size-letter) / 6) solid var(--artColor);
}

.artist-bubbles > .text {
  color: var(--artColor);
}

.artist-bubbles::before,
.artist-bubbles::after {
  background-color: var(--artColor);
}

/* Scientist-themed bubble styling */
.scientist-bubbles {
  border: calc(var(--size-letter) / 6) solid var(--sciColor);
}

.scientist-bubbles > .text {
  color: var(--sciColor);
}

.scientist-bubbles::before,
.scientist-bubbles::after {
  background-color: var(--sciColor);
}

/* Blend-themed bubble styling */
.blend-bubbles {
  border: calc(var(--size-letter) / 6) solid transparent;
  background: linear-gradient(var(--bckColor), var(--bckColor)) padding-box,
              var(--art-sci-gradient) border-box;
}

.blend-bubbles > .text {
  background: linear-gradient(to right, #E2A6A0, #7A71B9);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.blend-bubbles::before {
  background-color: rgba(248, 177, 155, 0.4); /* artColor */
}

.blend-bubbles::after {
  background-color: rgba(101, 103, 190, 0.4); /* sciColor */
}

.blend-bubbles:hover {
  & > .text {
    color: var(--textColor);
  }
  &::before,
  &::after {
    scale: 1;
  }
}


.cta-section {
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
}

.title-buttons {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: clamp(2rem, 5vw, 6rem);
  margin-top: 1rem;
  transform: scale(1);
  transition: transform 0.3s ease;
  width: 100%;
}

.button-group {
  flex: 1;
  max-width: 25rem;
  min-width: 0;
  position: relative;
  height: clamp(12.5rem, 18vh, 15rem);
  padding: 1.5rem 1rem;
  box-sizing: border-box;
  background: var(--bckColor);
  border-radius: var(--stdRadius);
  box-shadow: 0 0 0.2em 0 var(--blendOutlineColor);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.search-group::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  background: var(--sciOutlineColor);
  border-radius: var(--stdRadius);
  z-index: -1;
  opacity: 0.8;
}

.join-group::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  background: var(--artOutlineColor);
  border-radius: var(--stdRadius);
  z-index: -1;
  opacity: 0.8;
}

.button-group::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bckColor);
  border-radius: var(--stdRadius);
  z-index: -1;
}

.button-group > * {
  position: relative;
  z-index: 1;
}

.description {
  background-color: transparent;
  margin: 0;
  font-size: clamp(1.1rem, 2.5vw, 1.6rem);
  font-weight: 400;
  padding: 0;
  text-align: center;
  line-height: 1.4;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  white-space: normal;
  word-spacing: normal;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.question-text {
  font-size: clamp(1.1rem, 2.5vw, 1.6rem);
  color: var(--textColor);
  line-height: 1.4;
  text-align: center;
  margin: 0;
  display: block;
  padding: 0;
}

.search-group .description {
  border: none;
  color: var(--textColor);
}

.join-group .description {
  border: none;
  color: var(--textColor);
}

.scientist-text {
  color: var(--sciColor);
  font-weight: bold;
}

.artist-text {
  color: var(--artColor);
  font-weight: bold;
}

/* Mobile First Media Queries */
@media (max-width: 767px) {
  .title-buttons {
    flex-direction: row;
    gap: 1rem;
    transform: scale(0.9);
  }

  .button-group {
    max-width: none;
    width: 100%;
    flex: 1;
  }

  .description {
    font-size: clamp(0.85rem, 3.5vw, 1.1rem);
    padding: clamp(1rem, 2.5vw, 1.5rem);
    height: clamp(10rem, 18vh, 12rem);
    line-height: 1.3;
    gap: 1rem;
  }

  .question-text {
    font-size: clamp(0.85rem, 3.5vw, 1.1rem);
  }

  .logo {
    width: min(85vw, 20rem);
  }

  .welcome-box {
    padding: 1.5rem;
    margin: 0 0.5rem;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .title-buttons {
    transform: scale(0.85);
    gap: clamp(2rem, 4vw, 4rem);
  }
  
  .description {
    font-size: clamp(1.15rem, 2.8vw, 1.5rem);
    height: clamp(9rem, 16vh, 11rem);
    padding: clamp(1rem, 2.8vw, 1.3rem);
  }
  
  .logo {
    width: min(80vw, 35rem);
  }
}

@media (min-width: 1024px) {
  .title-buttons {
    transform: scale(0.9);
  }
  
  .logo {
    width: min(85vw, 45rem);
  }
}

@media (min-width: 1400px) {
  .title-buttons {
    transform: scale(1);
  }
  
  .logo {
    width: min(90vw, 45rem);
  }
}

/* Focus and interaction improvements */
.button-group:hover {
  /* Removed hover movement for stability */
}

/* Enhanced focus styles for accessibility */
.bubbles:focus {
  outline: 2px solid var(--sciColor);
  outline-offset: 2px;
}

.button-group:focus-within {
  outline: 2px solid var(--blendColor);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .logo,
  .title-buttons,
  .button-group {
    transition: none;
  }
}


</style>